module.exports = __webpack_public_path__ + "static/media/lastassister.a8ed4f0c.jpg";